import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { mobileIs } from "../../utils/siteUtils";
import "./style.scss";
import { gtag } from "../../utils";
import gsap from 'gsap';

const TitleAnimation = props => {
	const { lang, rendering, fields, page } = props;
	const { pc_first_title, pc_second_title, pc_description, m_first_title, m_second_title, m_description } = fields;
	const isMobile = mobileIs()
	const rootNode = useRef()
	const titleEl = useRef()
	const isAR = page?.fields?.rtl?.value;
	
	useEffect(() => {
		let ScrollMagic, controller, scene, tl;
		ScrollMagic = loadScrollMagic();
		controller = new ScrollMagic.Controller();
		tl = gsap.timeline();
		
		tl.add(gsap.to(titleEl.current,{
			x: isAR ? isMobile ? '-60px' : '-200px' : isMobile ? '60px' : '200px'
		}), 1)
		
		scene = new ScrollMagic.Scene({
		  triggerElement: rootNode.current,
		  triggerHook: 0,
		  offset: -window.innerHeight * 0.5, // 半屏左右时触发
		  duration: window.innerHeight * 0.01 // 短距离执行完scrollMagic 去执行transition动画
		})
		.setTween(tl)
		.addTo(controller)
		
		return () => {
		  scene.destroy(true);
		  scene = null;
		  controller.destroy(true);
		  controller = null;
		};
	}, [])
	
	const rootClasses = classNames("c-title-animation",  getOverallSettingsClasses(fields));
	return (
		<div className={rootClasses} ref={rootNode} datasourceid={rendering.dataSource}>
			<div className="c-title-animation_title">
				{!isMobile && <RichText className="c-title-animation_title_first" tag="div" field={pc_first_title} />}
				{!isMobile && <div className="c-title-animation_title_second" ref={titleEl} >
					<RichText tag="div" field={pc_second_title} />
				</div>}
				{isMobile && <RichText className="c-title-animation_title_first" tag="div" field={m_first_title} />}
				{isMobile && <div className="c-title-animation_title_second" ref={titleEl}>
					<RichText tag="div" field={m_second_title} />
				</div>}
			</div>
			{!isMobile && <RichText className="c-title-animation_description" tag="div" field={pc_description} />}
			{isMobile && <RichText className="c-title-animation_description" tag="div" field={m_description} />}
		</div>
	)
}

export default 	TitleAnimation;